/* @flow */
/* eslint-disable camelcase */
/* eslint-disable babel/no-invalid-this */
import BaseModel from "nexia_mobile/models/base_model";
import BaseCollection from "nexia_mobile/models/base_collection";
import followLink from "nexia_mobile/models/followLink";
import type { ScheduleFeature } from "./types";
import { getLanguageSet } from "nx-components/Locales";

export default function Schedule(feature: ScheduleFeature) {
  const getActiveScheduleAction = feature.actions.get_active_schedule;
  const getDefaultScheduleAction = feature.actions.get_default_schedule;
  const setActiveScheduleAction = feature.actions.set_active_schedule;
  const enableSchedulingAction = feature.actions.enable_scheduling;

  const createScheduleModelFromData = (data) => {
    let result = new BaseModel(data, { parse: true });
    result.set({
      can_add_remove_periods: feature.can_add_remove_periods,
      max_schedule_periods_per_day: feature.max_periods_per_day,
      max_period_name_length: feature.max_period_name_length,
    });
    return result;
  };

  this.enableScheduling = () => {
    const language = getLanguageSet().nexia_mobile.device_features.schedule;
    if (enableSchedulingAction) {
      return followLink(this, enableSchedulingAction, {
        data: enableSchedulingAction.data || "",
        fetchModelWhenDone: true,
      })
        .then(() => {
          if (this.parentGroup) {
            // If the device has a parentGroup and a scheduling feature, it's an
            // xxl zone. Refresh the parent thermostat as well.
            return this.parentGroup.fetch();
          }
          return Promise.resolve();
        })
        .then(
          () =>
            this.get("scheduling_enabled")
              ? { message: language.scheduleEnableSuccess, success: true }
              : { message: language.scheduleEnableFailure, success: false },
          // A rejection from followLink has already shown a toast
          () => null
        );
    } else {
      return Promise.reject(
        new Error(
          "Attempted to enable scheduling on a device with no enable scheduling action"
        )
      );
    }
  };

  this.getActiveSchedule = () => {
    if (getActiveScheduleAction) {
      return followLink(this, getActiveScheduleAction, {}).then((data) =>
        createScheduleModelFromData(data)
      );
    } else {
      return Promise.reject(
        new Error(
          "Attempted to get schedule on a device with no get schedule action"
        )
      );
    }
  };

  this.hasDefaultSchedule = () => {
    return Boolean(getDefaultScheduleAction);
  };

  this.getDefaultSchedule = () => {
    if (getDefaultScheduleAction) {
      return followLink(this, getDefaultScheduleAction, {}).then((data) =>
        createScheduleModelFromData(data)
      );
    } else {
      return Promise.reject(
        new Error(
          "Attempted to load default schedule on a device with no default schedule action"
        )
      );
    }
  };

  this.setActiveSchedule = (schedule) => {
    if (setActiveScheduleAction) {
      const options = {
        data: schedule.attributes,
        // make sure the schedule verifier on the server has more than enough time to finish its attempts
        maxRequestsCount: 120,
      };
      return followLink(this, setActiveScheduleAction, options);
    } else {
      return Promise.reject(
        new Error(
          "Attempted to set schedule on a device with no set schedule action"
        )
      );
    }
  };

  if (!this._scheduleCollection) {
    this._scheduleCollection = new BaseCollection();
  }
  this._scheduleCollection.setUrl(feature.collection_url);

  this.getScheduleCollection = () => {
    return this._scheduleCollection;
  };

  return {
    scheduling_enabled: feature.enabled,
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/schedule.js